module.exports = __webpack_public_path__ + "static/media/musikexempel.3fe1d4a7.jpg";